import React from 'react'

import { InformationDialog, DialogContent } from '@front/squirtle'

import { SuspensionPopupForm } from '@abra/elements/Suspensions'
import ShowActiveJobsPopup from '@abra/elements/Popup/ShowActiveJobs'
import VoucherFormPopup from './Voucher/Form'
import VoucherListPopup from './Voucher/List'

const Dialogs = ({ record_id }) => (
  <>
    <SuspensionPopupForm record_id={record_id} model_name={"company"} />
    <ShowActiveJobsPopup />
    <VoucherFormPopup record_id={record_id} />
    <InformationDialog name={'voucher_list'} maxWidth={'xl'}>
      <DialogContent>
        <VoucherListPopup />
      </DialogContent>
    </InformationDialog>
  </>
)

export default Dialogs
